
































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import { userType, common } from '@/app/model/store/domain/const'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* module */
import CommonClass from '@/app/module/common'
import VarietyListApi from '@/app/model/api/varietyListApi'
import DistrictListApi from '@/app/model/api/districtListApi'
import ExternalLinkDetailApi from '@/app/model/api/externalLinkDetailApi'
import ExternalLinkContentListApi from '@/app/model/api/externalLinkContentListApi'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'
import Local from '@/app/module/local'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  },
  metaInfo (this: ExternalLinkDetails): MetaInfo {
    return {
      title: CommonClass.getServiceFunctionData().external_link.external_link_name + '詳細 | ' + common.SYSTEM_NAME
    }
  }
})
export default class ExternalLinkDetails extends Vue {
  private alertText: string = ''
  private alertTitle: string = ''
  private externalLinkId: string = ''
  private externalLinkDetailData: any = {}

  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  private isAdmin: boolean = false
  private varietyData: any = []
  private districtData: any = []
  private varietyIdsData: any = []
  private districtIdsData: any = []
  private externalLinkContentData: any = []
  private externalLinkTitle: string = ''

  created () {
    if (Local.getUserType() === String(userType.USER_TYPE_ADMIN)) {
      this.isAdmin = true
    }
    this.getVarieties()
    this.getDistricts()

    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name
    this.externalLinkId = this.$route.params.external_link_id
    this.getExternalLinkDetail(this.externalLinkId)
    this.getExternalLinkContent(this.externalLinkId)
  }

  private getExternalLinkDetail (externalLinkId: string) {
    (async () => {
      const result = await ExternalLinkDetailApi.getDetail(externalLinkId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.externalLinkDetailData = payload
        this.varietyIdsData = this.choiceVarietyOptions(payload.variety.variety_options)
        this.districtIdsData = this.choiceDistrictOptions(payload.district.district_options)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private choiceVarietyOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.variety_id)
    }

    return ret
  }

  private choiceDistrictOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.district_id)
    }

    return ret
  }

  private getExternalLinkContent (externalLinkId: string) {
    (async () => {
      const result = await ExternalLinkContentListApi.getDetail(externalLinkId, '', '')
      if (result.isOk()) {
        const payload = result.getPayload()
        this.externalLinkContentData = payload.external_link_contents
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private displayContentTypeName (data: any): string {
    if (data.content_file !== '') {
      return 'ファイル'
    } else if (data.content_url !== '') {
      return 'URL'
    } else {
      return '-'
    }
  }

  private displayDate (date: string): string {
    const dateObj = new Date(date)
    return dateObj.getFullYear() + '年' + (dateObj.getMonth() + 1) + '月' + dateObj.getDate() + '日'
  }

  private doCancel () {
    this.$router.push('/external-link').catch(e => {})
  }

  private doActualCreate () {
    const path = '/external-link/' + this.externalLinkId + '/content/create'
    this.$router.push(path).catch(e => {})
  }

  private doActualEdit (externalLinkContentId: string) {
    const path = '/external-link/' + this.externalLinkId + '/content/' + externalLinkContentId
    this.$router.push(path).catch(e => {})
  }

  private doExternalLinkEdit () {
    const path = '/external-link/' + this.externalLinkId + '/edit'
    this.$router.push(path).catch(e => {})
  }

  // 品種情報取得
  private getVarieties () {
    (async () => {
      this.showLoading = true
      const data = {
        word: '',
        order_name: 'variety_name',
        sort: true
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから操作をしてください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  /* 地区取得 */
  private getDistricts () {
    (async () => {
      this.showLoading = true
      const data : any = {
        sortName: 'district_name',
        sort: 'asc',
        text: ''
      }

      const result = await DistrictListApi.getDistrictList(data)

      if (result.isOk()) {
        this.districtData = result.getPayload().results
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private async getExternalLinkFile (id: number, content_name: string) {
    const objectURL = await GetExternalLinkFileApi.getExternalLinkFile(id)
    if (typeof objectURL === 'string') {
      let link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectURL
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectURL)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }
}
